module.exports = __webpack_public_path__ + "img/52.61a3a80b.jpg";